import type { DimensionModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import DimensionSelector from "@/features/react-editor/components/modifiers/base/DimensionSelector";
import { useSelectedElement } from "@/features/react-editor/components/modifiers/store/ModifiersStoreContext";

interface WidthModifierProps {
  onChange: (modifiers: DimensionModifierValue[]) => void;
}

const WidthModifier: React.FC<WidthModifierProps> = ({ onChange }) => {
  const selectedElement = useSelectedElement();

  const currentValue = selectedElement?.styleOverrides?.width ?? null;

  const handleValueChange = (width: number | "auto" | "full" | null) => {
    if (width !== null) {
      onChange([
        {
          type: "dimension" as const,
          side: "width",
          value: width,
        },
      ]);
    }
  };

  return (
    <div className="width-modifier">
      <DimensionSelector
        value={currentValue}
        onSelect={handleValueChange}
        placeholder="Select width"
      />
    </div>
  );
};

export default WidthModifier;
